import React from 'react';
import {
  FaEdit,
  FaTrashAlt,
  FaEye,
  FaLock,
  FaToggleOn,
  FaToggleOff,
  FaPlus,
  FaSave,
  FaDownload,
  FaPaperPlane,
  FaPrint,
  FaSync,
  FaFilter,
  FaCog,
  FaUnlock,
  FaSignOutAlt,
  FaBell,
  FaQuestionCircle,
  FaBoxes,
} from 'react-icons/fa';

const actionButtons: Record<string, { className: string; icon: JSX.Element }> =
  {
    edit: {
      className: 'bg-primary text-white hover:bg-opacity-90',
      icon: <FaEdit size={18} />,
    },
    delete: {
      className: 'bg-[#DC3545] text-white hover:bg-opacity-90',
      icon: <FaTrashAlt size={18} />,
    },
    view: {
      className: 'bg-blue-500 text-white hover:bg-opacity-90',
      icon: <FaEye size={18} />,
    },
    password: {
      className: 'bg-yellow-500 text-white hover:bg-opacity-90',
      icon: <FaLock size={18} />,
    },
    toggleOn: {
      className: 'bg-green-500 text-white hover:bg-opacity-90',
      icon: <FaToggleOn size={18} />,
    },
    toggleOff: {
      className: 'bg-red text-white hover:bg-opacity-90',
      icon: <FaToggleOff size={18} />,
    },
    add: {
      className: 'bg-blue-500 text-white hover:bg-opacity-90',
      icon: <FaPlus size={18} />,
    },
    save: {
      className: 'bg-green-500 text-white hover:bg-opacity-90',
      icon: <FaSave size={18} />,
    },
    download: {
      className: 'bg-indigo-500 text-white hover:bg-opacity-90',
      icon: <FaDownload size={18} />,
    },
    send: {
      className: 'bg-purple-500 text-white hover:bg-opacity-90',
      icon: <FaPaperPlane size={18} />,
    },
    print: {
      className: 'bg-orange-500 text-white hover:bg-opacity-90',
      icon: <FaPrint size={18} />,
    },
    refresh: {
      className: 'bg-teal-500 text-white hover:bg-opacity-90',
      icon: <FaSync size={18} />,
    },
    filter: {
      className: 'bg-cyan-500 text-white hover:bg-opacity-90',
      icon: <FaFilter size={18} />,
    },
    settings: {
      className: 'bg-gray-700 text-white hover:bg-opacity-90',
      icon: <FaCog size={18} />,
    },
    unlock: {
      className: 'bg-yellow-500 text-white hover:bg-opacity-90',
      icon: <FaUnlock size={18} />,
    },
    logout: {
      className: 'bg-red text-white hover:bg-opacity-90',
      icon: <FaSignOutAlt size={18} />,
    },
    notifications: {
      className: 'bg-pink-500 text-white hover:bg-opacity-90',
      icon: <FaBell size={18} />,
    },
    help: {
      className: 'bg-blue-400 text-white hover:bg-opacity-90',
      icon: <FaQuestionCircle size={18} />,
    },
    settle: {
      className: 'bg-primary text-white hover:bg-opacity-90',
      icon: <FaBoxes size={18} />, // ¡Mejor representación visual!
    },
  };

interface Action {
  key: string;
  onClick: (row: any) => void;
}

interface IconButtonActionsProps {
  actions: Action[];
  row: any;
}

const IconButtonActions: React.FC<IconButtonActionsProps> = ({
  actions,
  row,
}) => {
  return (
    <div className="flex gap-2">
      {actions.map((action, index) => {
        let buttonKey = action.key;

        if (action.key === 'toggle') {
          // ✅ Detecta automáticamente si el row usa enabled o status
          const state = row.enabled ?? row.status;
          buttonKey = state ? 'toggleOn' : 'toggleOff';
        }

        const buttonData = actionButtons[buttonKey];

        return (
          <button
            key={index}
            onClick={() => action.onClick(row)}
            className={`inline-flex items-center justify-center rounded-md p-2 transition-all duration-200 ${buttonData.className}`}
          >
            {buttonData.icon}
          </button>
        );
      })}
    </div>
  );
};

export default IconButtonActions;
